
export default {
    name: 'Button',
    props: {
        theme: {
            type: String,
            default: () => 'primary',
            validator (value) {
                return ['primary', 'primary-light', 'secondary', 'alert'].includes(value)
            }
        }
    }
}
